import '../../styles/variables.css';
import styled from 'styled-components';
import { FlexColumn } from './Flex';

//this is a box that we can put selectable shit in
//as of alpha design, it has organge borders and drop shadows
export const ControlBox = styled(FlexColumn)`
    background-color: #ffffff;
    border: 2px solid var(--jargon-primary);
    box-shadow: var(--box-shadow-depth) var(--box-shadow-depth) 0px 0px var(--jargon-primary);
    padding:35px;
`;
export const ControlBoxHeader = styled.h2`
    font-size:calc(1.5rem - 2px);
    border-bottom:2px solid var(--jargon-primary);
    font-weight:700;
    padding-bottom:.5rem;
    margin-bottom:1rem;
`;
export const ControlBoxLabel = styled.span`
    color:var(--jargon-primary);
    margin-right:.5rem;
`;

export const SettingsContainer = styled.div`
    margin-bottom: var(--vertical-spacing);
`;